import { Component, ViewEncapsulation } from "@angular/core";
import { TransferCertificateServices } from "./transfer-certificate-report.services";
import { firstValueFrom } from "rxjs";
import * as transferCertificateString from "../stringFiles/transferCertificate.json";
import { TranslateService } from '@ngx-translate/core';


declare var $: any;
declare var customToastr: any;

@Component({
  selector: "app-transfer-certificate-report",
  providers: [TransferCertificateServices],
  templateUrl: "./transfer-certificate-report.component.html",
  styleUrls: [
    "./transfer-certificate-report.component.css",
    "./../../assets/css/theme-default/materialadmin.css",
    "./../../assets/css/theme-default/font-awesome.min.css",
    "./../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css",
    "./../../assets/css/theme-default/material-design-iconic-font.min.css",
    "./../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css",
    "./../../_crop/css/style.css",
    "./../../_crop/css/style-example.css",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class TransferCertificateReportComponent {
  isFilterExpanded: boolean = false;
  wingListData: [];
  selectedWing: any = null;
  selectedClass: any = null;
  selectedSection: any = null;
  selectedCaste: any = null;
  selectedGender: any = null;
  classStandardData: [];
  genderData: [];
  categoryData: [];
  classSectionData: [];
  wingId: string = "";
  stringsData: any;
  fetchingSectionData: boolean = false;
  appliedFilterData: any;
  tcStatInfo: [];
  tableHeaderData: string[];
  tcResultsAvailable: string = "";
  columnIndex: string = "";
  tableRowData: [];
  maxPageNumber: number;
  pageNumbers: number[];
  startingPageNumber: number = 1;
  pageLimit: string = "10";
  enableReset: boolean = false;
  isLoadingStatData: boolean = false;
  isLoadingTableData: boolean = false;
  isLoadingClassInfo: boolean = false;
  isLoadingWingInfo: boolean = false;
  isExportingReport :boolean = false;
  lang : string = "en";


  appliedWing : any = "All";
  appliedClassStandard : any = "All";
  appliedClassId : any = "All"; 
  appliedGender : any = 'All';
  appliedCaste : any = 'All';

  constructor(
    private transferCertificateServices: TransferCertificateServices
    , private translate: TranslateService
  ) {
    this.stringsData = transferCertificateString;
    this.getWingListData();
    this.getCategoryList();
    this.getGenderListData();
    this.getTcStats();
    this.getTcDetailedTableInfo(this.pageLimit);
  }

  initScript() {
    $(".after").empty();
    $("#device-breakpoints").remove();
    $(".after").append(
      "<script>function customToastr(message,type){toastr.options.hideDuration = 0;toastr.clear();" +
        "toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;" +
        "toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;" +
        "toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';" +
        "toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';" +
        "toastr[type](message, '');return 0;} </" +
        "script>"
    );
  }

  // function for get wing list for selection
  async getWingListData() {
    try {
      this.isLoadingWingInfo = true;
      const response: any = await firstValueFrom(
        this.transferCertificateServices.getWingData()
      );
      if (response.status && response.body) {
        this.wingListData = response.body.classCategoryListDetails
          ? response.body.classCategoryListDetails
          : [];
        this.classStandardData = [];
        this.classSectionData = [];
      } else {
        this.wingListData = [];
      }
      this.isLoadingWingInfo = false;
    } catch (error) {
      this.wingListData = [];
      this.isLoadingWingInfo = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.stringsData.error);
      } else {
        const somethingWentWrongTranslation = await firstValueFrom(this.translate.get('somethingWentWrong'));
        customToastr(somethingWentWrongTranslation, this.stringsData.error);
      }
    }
  }

  // function for get class standard
  async getClassStandardList(wingInfo) {
    try {
      this.selectedSection = null;
      this.selectedClass =null;
      this.classStandardData = [];
      this.classSectionData = [];
      this.isLoadingClassInfo = true;
      this.wingId = wingInfo.categoryId;
      const response: any = await firstValueFrom(
        this.transferCertificateServices.getClassStandardList(
          wingInfo.categoryId
        )
      );

      if (response.status && response.body) {
        this.classStandardData = response.body.classCategoryListData
          ? response.body.classCategoryListData
          : [];
        this.classSectionData = [];
      } else {
        this.classStandardData = [];
      }
      this.isLoadingClassInfo = false;
      this.classSectionData = [];
    } catch (error) {
      this.classStandardData = [];
      this.classSectionData = [];
      this.isLoadingClassInfo = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.stringsData.error);
      } else {
        const somethingWentWrongTranslation = await firstValueFrom(this.translate.get('somethingWentWrong'));
        customToastr(somethingWentWrongTranslation, this.stringsData.error);
      }
    }
  }

  // function for get section list data
  async getClassSectionList(classStandardInfo) {
    try {
      this.selectedSection = null;
      this.classSectionData = [];
      this.fetchingSectionData = true;
      const response: any = await firstValueFrom(
        this.transferCertificateServices.getClassSectionData(
          this.wingId,
          classStandardInfo.pkClassStandardsId
        )
      );
      if (response.status && response.body) {
        this.classSectionData = response.body.classSectionListData
          ? response.body.classSectionListData
          : [];
      } else {
        this.classSectionData = [];
      }
      this.fetchingSectionData = false;
    } catch (error) {
      this.classSectionData = [];
      this.fetchingSectionData = false;
      if (error?.error?.message) {
        customToastr(error.error.message, this.stringsData.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
        customToastr(errorMessageTranslation, this.stringsData.error);
      }
    }
  }

  // function for get class section list
  async getCategoryList() {
    try {
      const response: any = await firstValueFrom(
        this.transferCertificateServices.getCategoryData()
      );
      if (response.status && response.body) {
        this.categoryData = response.body.castCategoryListDetails
          ? response.body.castCategoryListDetails
          : [];
      } else {
        this.categoryData = [];
      }
    } catch (error) {
      this.categoryData = [];
      if (error?.error?.message) {
        customToastr(error.error.message, this.stringsData.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
        customToastr(errorMessageTranslation, this.stringsData.error);
      }
    }
  }

  // function for get class section list
  async getGenderListData() {
    try {
      const response: any = await firstValueFrom(
        this.transferCertificateServices.getGenderList()
      );
      if (response.status && response.body) {
        this.genderData = response.body.studentGenderListDetails
          ? response.body.studentGenderListDetails
          : [];
      } else {
        this.genderData = [];
      }
    } catch (error) {
      this.genderData = [];
      if (error?.error?.message) {
        customToastr(error.error.message, this.stringsData.error);
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
        customToastr(errorMessageTranslation, this.stringsData.error);
      }
    }
  }

  // function for expand filter
  expandFilter() {
    this.isFilterExpanded = !this.isFilterExpanded;
  }

  // function for apply filter
  applyFilter() {
    this.enableReset = true;
    const all = "All";
    this.startingPageNumber=1;
    this.appliedWing =   this.selectedWing != null ? this.selectedWing.categoryId : all ;
    this.appliedClassStandard = this.selectedSection != null ? this.selectedSection.classId : all;
    this.appliedClassId = this.selectedClass != null ? this.selectedClass.pkClassStandardsId: all;
    this.appliedCaste =    this.selectedCaste != null ? this.selectedCaste.castCategory : all;
    this.appliedGender = this.selectedGender != null ? this.selectedGender.studentGender : all
    const body = [
      {
        wing:
          this.selectedWing != null ? this.selectedWing.classCategoryName : all,
        class:
          this.selectedClass != null
            ? this.selectedClass.classStandardName
            : all,
        section:
          this.selectedSection != null
            ? this.selectedSection.classDivision
            : all,
        caste:
          this.selectedCaste != null ? this.selectedCaste.castCategory : all,
        gender:
          this.selectedGender != null ? this.selectedGender.studentGender : all,
      },
    ];
    this.getTcStats();
    this.getTcDetailedTableInfo(this.pageLimit);
    this.appliedFilterData = body;
  }

    // function for apply filter
    applyAfterResetFilter() {
      this.enableReset = true;
      const all = "All";
      this.startingPageNumber=1;

      this.appliedWing =   all;
      this.appliedClassId = all;
      this.appliedClassStandard = all;
      this.appliedCaste =    all
      this.appliedGender = all;
      const body = [
        {
          wing:
            this.selectedWing != null ? this.selectedWing.classCategoryName : all,
          class:
            this.selectedClass != null
              ? this.selectedClass.classStandardName
              : all,
          section:
            this.selectedSection != null
              ? this.selectedSection.classDivision
              : all,
          caste:
            this.selectedCaste != null ? this.selectedCaste.castCategory : all,
          gender:
            this.selectedGender != null ? this.selectedGender.studentGender : all,
        },
      ];
      this.getTcStats();
      this.getTcDetailedTableInfo(this.pageLimit);
      this.appliedFilterData = body;
    }

  // function for get tc stats
  async getTcStats() {
    try {
      this.isLoadingStatData = true;
      const wing = this.appliedWing
      const classId = this.appliedClassId
      const section = this.appliedClassStandard
      const gender = this.appliedGender
      const caste = this.appliedCaste
      const response: any = await firstValueFrom(
        this.transferCertificateServices.getStudentTcStats(
          wing,
          classId,
          section,
          caste,
          gender
        )
      );
      if (response.status && response.body) {
        this.tcStatInfo = response.body.tcOrBirthCertificateCount
          ? response.body.tcOrBirthCertificateCount
          : [];
        this.tcResultsAvailable = response.body.resultAvailable
          ? response.body.resultAvailable
          : "0";
      } else {
        this.tcStatInfo = [];
        this.tcResultsAvailable = "0";
      }
      this.isLoadingStatData = false;
    } catch (error) {
      this.isLoadingStatData = false;
      this.tcStatInfo = [];
      this.tcResultsAvailable = "0";
      const somethingWentWrongTranslation = await firstValueFrom(this.translate.get('somethingWentWrong'));
      customToastr(error.error.message ? error.error.message : somethingWentWrongTranslation , "error");
    }
  }

  // function for select all wing
  applyAllWing() {
    this.selectedClass = null;
    this.selectedSection = null;
    this.classStandardData = [];
    this.classSectionData = [];
  }

  // function for select all class
  applyAllClass() {
    this.selectedClass = null;
    this.selectedSection = null;
    this.classSectionData = [];
  }

  // function for update table column
  async updateTableColumn(currentSlug, newSlug) {
    const currentSlugDataIndex = this.tableHeaderData.findIndex((item) => {
      const data = item as any;
      return data.slug === currentSlug;
    });
    const newSlugDataIndex = this.tableHeaderData.findIndex((item) => {
      const data = item as any;
      return data.slug === newSlug;
    });
    if (currentSlugDataIndex !== -1 && newSlugDataIndex !== -1) {
      const slugCurrentData = this.tableHeaderData[currentSlugDataIndex];
      const slugNewData = this.tableHeaderData[newSlugDataIndex];
      const currentInfo = slugCurrentData as any;
      const newInfo = slugNewData as any;
      currentInfo.isDefault = 0;
      newInfo.isDefault = 1;
      if (this.tableHeaderData.length > 0) {
        this.tableHeaderData[currentSlugDataIndex] = newInfo;
        this.tableHeaderData[newSlugDataIndex] = currentInfo;
      }
    }
  }

  // function for open column function
  expandColumnOption(index) {
    if(index===this.columnIndex){
      this.columnIndex ="";
    }
    else{
      this.columnIndex = index;
    }
  }

  // function for get table data student tc info
  async getTcDetailedTableInfo(pageLimit) {
    try {
      this.isLoadingTableData = true;
      const wing = this.appliedWing;
      const classId = this.appliedClassId;
      const section = this.appliedClassStandard;
      const gender = this.appliedGender;
      const caste = this.appliedCaste;
      const response: any = await firstValueFrom(
        this.transferCertificateServices.getTcDetailedInfo(
          wing,
          classId,
          section,
          caste,
          gender,
          pageLimit,
          this.startingPageNumber
        )
      );
      if (response.status && response.body) {
        if (this.tableHeaderData === undefined) {
          this.tableHeaderData = response.body.reportColumnList
            ? response.body.reportColumnList
            : [];
        }
        this.generatePageNumber(
          response.body.maxPageNumber ? response.body.maxPageNumber : 1
        );
        this.tableRowData = response.body.reportStudentData
          ? response.body.reportStudentData
          : [];
      } else {
        this.tableHeaderData = [];
        this.tableRowData = [];
      }
      this.isLoadingTableData = false;
    } catch (error) {
      this.isLoadingTableData = false;
      this.tableHeaderData = [];
      this.tableRowData = [];
      const somethingWentWrongTranslation = await firstValueFrom(this.translate.get('somethingWentWrong'));
      customToastr(error.error.message ? error.error.message : somethingWentWrongTranslation , "error");
    }
  }

  // function for close table column options
  collapseColumnOption() {
    this.columnIndex = "";
  }

  // function for generate page number
  generatePageNumber(maxPage) {
    this.maxPageNumber = maxPage;
    let displayedPages = [];
    let currentPage = this.startingPageNumber;
    if (currentPage === 1) {
      displayedPages.push(
        ...Array.from({ length: Math.min(5, maxPage) }, (_, i) => i + 1)
      );
    } else if (currentPage === maxPage) {
      displayedPages.push(
        ...Array.from(
          { length: Math.min(5, maxPage) },
          (_, i) => maxPage - 4 + i
        )
      );
    } else if (currentPage >= 4 && currentPage <= maxPage - 3) {
      displayedPages.push(
        ...Array.from({ length: 5 }, (_, i) => currentPage - 2 + i)
      );
    } else if (currentPage < 4) {
      displayedPages.push(
        ...Array.from({ length: Math.min(5, maxPage) }, (_, i) => i + 1)
      );
    } else if (currentPage > maxPage - 4) {
      displayedPages.push(
        ...Array.from(
          { length: Math.min(5, maxPage) },
          (_, i) => maxPage - 4 + i
        )
      );
    }
    displayedPages = displayedPages
      .filter((page) => page > 0 && page <= maxPage)
      .sort((a, b) => a - b);
    if (!displayedPages.includes(maxPage)) {
      displayedPages.push("...");
      displayedPages.push(maxPage);
    }
    this.pageNumbers = displayedPages;
  }

  // function for change page number through left right button
  changePage(pageValue) {
    if (pageValue != 0 && pageValue <= this.maxPageNumber) {
      this.startingPageNumber = pageValue;
      this.getTcDetailedTableInfo(this.pageLimit);
    }
  }

  // function for jump page number on click of page number
  switchPageNumber(pageNumber) {
    this.startingPageNumber = pageNumber;
    this.getTcDetailedTableInfo(this.pageLimit);
  }

  // function for update table length list
  changePageLimitData(pageNumber) {
    this.startingPageNumber = 1;
    this.pageLimit = pageNumber;
    this.getTcDetailedTableInfo(this.pageLimit);
  }

  // function for reset filter
  resetFilter() {
    this.selectedWing = null;
    this.selectedClass = null;
    this.selectedSection = null;
    this.selectedCaste = null;
    this.selectedGender = null;
    this.appliedFilterData = null;
    this.applyFilter();
    this.enableReset = false;
    this.getTcStats();
  }

    // function for export tc/birth certificate report and download it directly
    async exportReport(){
      try{
        this.isExportingReport = true;
        const tableColumnArray = []
        for(let j=0;j<this.tableHeaderData.length;j++){
          const tableData : any= this.tableHeaderData[j];
          if(tableData.isDefault==1){
            tableColumnArray.push(tableData.pkReportColumnMapDetailId);
          }
        }
      const schoolData = localStorage.getItem('schoolAllInfo');
      const schoolInfo = JSON.parse(schoolData)

        const body ={
          lang: this.lang,
          academicId: schoolInfo.currentAcademicId,
          exportType: this.stringsData.reportFormat,
          selectedColumns: tableColumnArray,
          emailIdList: [],
          classCategoryId: this.selectedWing ? this.selectedWing.categoryId: this.stringsData.all,
          classStandardId: this.selectedClass ? this.selectedClass.pkClassStandardsId : this.stringsData.all,
          classId: this.selectedSection ? this.selectedSection.classId : this.stringsData.all,
          gender: this.selectedGender ? this.selectedGender.studentGender : this.stringsData.all,
          castCategory: this.selectedCaste ? this.selectedCaste.castCategory : this.stringsData.all
        }

        const response : any = await firstValueFrom(this.transferCertificateServices.exportReportData(body));
        if(response instanceof Blob){
          const url = window.URL.createObjectURL(response);
          const a = document.createElement("a");
          a.href = url;
          a.download = "TcOrBirthCertificateReport.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
        }
        const successMsg = await firstValueFrom(this.translate.get('reportExportedSuccessfully'));
        customToastr(successMsg, "success");
      }
      catch(error){
        const somethingWentWrongTranslation = await firstValueFrom(this.translate.get('somethingWentWrong'));
        customToastr(error.error && error.error.message ? error.error.message : somethingWentWrongTranslation , "error");
      }
      finally{
        this.isExportingReport = false;
      }
    }

}